import React from 'react'
import { cn } from '@/lib/utils'

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  striped?: boolean
  bordered?: boolean
  hover?: boolean
  responsive?: boolean
  size?: string
}

export const Table: React.FC<TableProps> = ({
  striped, bordered, hover, responsive, size, className, children, ...props
}) => {
  const table = (
    <table
      className={cn(
        'w-full text-sm',
        striped && '[&_tbody_tr:nth-child(odd)]:bg-muted/50',
        bordered && 'border border-border [&_td]:border [&_th]:border',
        hover && '[&_tbody_tr]:hover:bg-muted',
        size === 'sm' && '[&_td]:py-1 [&_th]:py-1',
        className,
      )}
      {...props}
    >
      {children}
    </table>
  )
  if (responsive) return <div className="overflow-x-auto">{table}</div>
  return table
}
